import * as React from "react";

import {cs}                      from "@Common/react/chain-services";
import {UseState}                from "@Common/react/use-state";
import {getPageSummary}          from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {Pagination}              from "@Common/ui-components/heavy/common/design2/data-table/pagination";
import {Sorting}                 from "@Common/ui-components/heavy/common/design2/data-table/sorting";
import {PageList}                from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize, PAGE_SIZE_ALL} from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {chain}                   from "@Common/utils/fs";

import {dnmCard} from "./dnm-card";

import "./dnm-list.scss";

export const DnmList = ({sortedList, officeId, dnmList}) => cs(
    ["pageSize", (_, next) => UseState({next, getInitValue: () => 5})],
    ["sorting", (_, next) => Sorting({
        getDefault: undefined,
        next,
    })],
    ["sortedRows", ({sorting}, next) => next(sortedList && chain(
        sortedList,
        (_) => sorting.apply(_, (row, columnIndex) => row.columns[columnIndex].sortValue()),
    ))],
    ["pagination", ({sortedRows, pageSize}, next) => Pagination({
        _key: JSON.stringify(pageSize),
        pageSize: pageSize.value,
        rows: sortedRows,
        next,
    })],
    ["displayedRows", ({pagination, sortedRows}, next) => next(pagination?.active ? pagination.getDisplayedRows() : sortedRows)],
    ({}, next) => (
        <div className="dnm-table-d2rk">
            {next()}
        </div>
    ),
    ({pagination, pageSize, displayedRows}) => (
        <>
            {!displayedRows.length ? (
                <div className="no-records" xd-qa-type="label" xd-qa-name="No Addresses Found">
                    No Addresses Found
                </div>
            ) : (
                displayedRows.map((item) => (
                    <span key={item.idPrimary}>
                        {dnmCard({
                            item,
                            officeId,
                            dnmList,
                        })}
                    </span>
                )
            ))}
            {displayedRows.length ? <div className="controls">
                {PageSize({
                    sizes: [5, 10, 20],
                    state: pageSize,
                    extraSizes: [PAGE_SIZE_ALL],
                    pageSizeMessage: "",
                })}

                {<>
                    {pagination.active && <div className="pagination">
                        {PageList(pagination)}
                    </div>}

                    {getPageSummary({
                        pageIndex: pagination.state.value,
                        pageSize: pageSize.value,
                        count: sortedList.length
                    })}
                </>}
            </div> : ""}
        </>
    )
)
